import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path } from 'react-native-svg'

const Divider: FC = () => {
    return (
        <Svg height="2" fill="none" style={{ maxWidth: 640, width: '100%' }}>
            <Path d="M0 1H640" stroke={ColorEnum.GRAY_200} />
        </Svg>
    )
}

export default Divider
